/* eslint-disable no-console */
import { datadogRum } from "@datadog/browser-rum";

import firebase from "firebase/compat/app";
import "firebase/compat/auth";

datadogRum.init({
  applicationId: "a98621ad-8fce-4404-a396-9a07d84294dd",
  clientToken: "pube212823880bec0c727273faacdcc502d",
  site: "datadoghq.eu",
  service: "talentbait-app",
  // Specify a version number to identify the deployed version of your application in Datadog
  // version: '1.0.0',
  env: window.env,
  beforeSend: (event, context) => {
    //console.log("DataDogRum", "beforeSend", context && context.user && context.user.email);
    if (
      firebase.auth() &&
      firebase.auth().currentUser &&
      firebase.auth().currentUser.email === "nils+datadog@talentbait.com"
    ) {
      return false; // Prevent this event from being sent
    }
  },
  sampleRate: 100,
  trackInteractions: true,
  // Enable this line if we want to use session recording
  defaultPrivacyLevel: "allow",
  trackSessionAcrossSubdomains: true,
  useSecureSessionCookie: true,
  useCrossSiteSessionCookie: true
});

// Enable this line if we want to use session recording
datadogRum.startSessionReplayRecording();

export default datadogRum;
